import { isEqual, isEqualWith } from 'lodash';

const comparator = (a: object, b: object) => {
  if (Array.isArray(a) && Array.isArray(b)) {
    return isEqual(a, b);
  }

  return undefined;
};

// Using json parse/stringify to remove undefined values.
// instead of using structuredClone which keeps some values we do not care for.
const clone = (obj: unknown) => JSON.parse(JSON.stringify(obj));

export class EqualityChecker {
  protected clone: unknown;

  public track(obj: unknown) {
    this.clone = clone(obj);
  }

  public areEqual(obj: unknown) {
    const current = clone(obj);
    return isEqualWith(current, this.clone, comparator);
  }

  public hasChanges(obj: unknown) {
    return !this.areEqual(obj);
  }
}
